(() => {
  if (customElements.get('futopia-welcome-film')) return;
  customElements.define('futopia-welcome-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController(); const options = { signal: this.abort.signal };
      this.video = this.querySelector('video'); this.playButton = this.querySelector('[data-play]');
      this.filmCue = this.querySelector('[data-cue]'); this.filmCueText = this.filmCue.textContent;
      this.progress = this.querySelector('.ft-film__progress span');
      this.mobile = matchMedia('(max-width:699px)'); this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.configure = this.configure.bind(this); this.schedule = this.schedule.bind(this);
      this.mobile.addEventListener('change', this.configure, options);
      this.reduce.addEventListener('change', this.configure, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', () => {
        if (this.scrolling && this.geometryWidth !== document.documentElement.clientWidth) this.measure();
        this.schedule();
      }, options);
      const v = this.video;
      v.addEventListener('loadeddata', () => { this.setAttribute('data-ready', ''); this.filmCue.textContent = this.filmCueText; this.schedule(); }, options);
      v.addEventListener('seeked', () => {
        this.lastSeekMs = performance.now() - (this.seekStarted || performance.now());
        this.setAttribute('data-ready', ''); this.schedule();
      }, options);
      v.addEventListener('playing', () => { this.setAttribute('data-ready', ''); this.playButton.textContent = this.playButton.dataset.pauseLabel; }, options);
      v.addEventListener('pause', () => { this.playButton.textContent = this.finished ? this.playButton.dataset.replayLabel : this.playButton.dataset.playLabel; }, options);
      v.addEventListener('ended', () => { this.finished = true; this.playButton.textContent = this.playButton.dataset.replayLabel; }, options);
      v.addEventListener('timeupdate', () => { if (!this.scrolling && v.duration) this.progress.style.transform = `scaleX(${v.currentTime / v.duration})`; }, options);
      v.addEventListener('error', () => { this.removeAttribute('data-ready'); this.playButton.hidden = false; this.filmCue.hidden = true; }, options);
      this.playButton.addEventListener('click', () => {
        if (this.scrolling) { this.manualOverride = true; this.configure(); }
        this.loadVideo();
        if (v.paused) { if (this.finished) { v.currentTime = 0; this.finished = false; } this.userPaused = false; v.play().catch(() => {}); }
        else { this.userPaused = true; v.pause(); }
      }, options);
      this.querySelector('[data-skip]').addEventListener('click', () => {
        const target = document.querySelector('.shopify-section--featured-collections') || this.closest('.shopify-section').nextElementSibling;
        target?.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) v.pause(); else if (this.scrolling) this.schedule(); else if (this.visible) this.autoplay();
      }, options);
      this.configure();
      document.fonts?.ready.then(() => { if (this.isConnected && this.scrolling && scrollY < 1) { this.measure(); this.schedule(); } });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.scrolling) { if (this.visible) this.schedule(); }
        else if (!this.visible) v.pause(); else this.autoplay();
      });
      this.observer.observe(this);
    }
    source() { return this.mobile.matches && this.video.dataset.mobileSrc ? this.video.dataset.mobileSrc : this.video.dataset.src; }
    loadVideo() {
      if (!this.video.getAttribute('src')) { this.video.src = this.source(); this.video.load(); }
    }
    autoplay() {
      if (this.scrolling || this.reduce.matches || navigator.connection?.saveData || this.finished || this.userPaused || this.manualOverride || (this.mobile.matches && this.dataset.mobileMode === 'manual')) return;
      this.loadVideo(); this.video.play().catch(() => {});
    }
    async prepareScrollVideo() {
      // A full local Blob avoids new network range requests during reverse seeks.
      // The MP4 has independent I-frames; the browser still renders native video.
      const signal = this.mediaAbort.signal;
      const source = this.source();
      const optimized = source === this.video.dataset.optimizedFor ? this.video.dataset.scrollSrc : source;
            this.filmCue.textContent = this.filmCue.dataset.loadingLabel || 'Loading film…';
      try {
        const response = await fetch(optimized, { signal, cache: 'force-cache' });
        if (!response.ok) throw new Error('Film download failed');
        const blob = await response.blob();
        if (signal.aborted) return;
        this.blobURL = URL.createObjectURL(blob); this.video.src = this.blobURL;
        this.video.preload = 'auto'; this.video.load();
      } catch (error) {
        if (signal.aborted) return;
        this.video.src = optimized; this.video.preload = 'auto'; this.video.load();
      }
    }
    configure() {
      const v = this.video; v.pause(); this.mediaAbort?.abort();
      v.removeAttribute('src'); v.load();
      if (this.blobURL) URL.revokeObjectURL(this.blobURL); this.blobURL = null;
      this.removeAttribute('data-ready'); this.finished = false;
      const selected = this.mobile.matches ? this.dataset.mobileMode : this.dataset.mode;
      this.scrolling = selected === 'scroll' && !this.manualOverride && !this.reduce.matches && !navigator.connection?.saveData;
      this.classList.toggle('is-scroll', this.scrolling);
      this.playButton.hidden = this.scrolling; this.filmCue.hidden = !this.scrolling;
      this.progress.style.transform = 'scaleX(0)';
      if (this.scrolling) {
        this.mediaAbort = new AbortController(); this.measure(); this.prepareScrollVideo(); this.schedule();
      } else { if (this.visible) this.autoplay(); }
    }
    measure() {
      this.geometryWidth = document.documentElement.clientWidth;
      const stage = this.querySelector('.ft-film__stage'), visual = this.querySelector('.ft-film__visual');
      for (const key of ['--film-height', '--film-visual-height', '--film-sticky-top']) this.style.removeProperty(key);
      this.style.setProperty('--film-copy-height', this.querySelector('.ft-film__copy').offsetHeight + 'px');
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      this.startY = this.getBoundingClientRect().top + scrollY - top;
      this.travel = Math.max(1, this.offsetHeight - stage.offsetHeight);
      this.style.setProperty('--film-height', this.offsetHeight + 'px');
      this.style.setProperty('--film-visual-height', visual.offsetHeight + 'px');
      this.style.setProperty('--film-sticky-top', top + 'px');
    }
    schedule() {
      if (this.scrolling && !this.raf && !document.hidden) this.raf = requestAnimationFrame(() => { this.raf = 0; this.draw(); });
    }
    draw() {
      if (!this.scrolling) return;
      const v = this.video;
      const p = Math.max(0, Math.min(1, (scrollY - this.startY) / this.travel));
      if (!Number.isFinite(v.duration) || v.readyState < 2) return;
      const frames = Math.max(1, Math.round(v.duration * 30) - 1);
      this.targetFrame = Math.round(p * frames);
      this.targetTime = this.targetFrame / 30;
      this.progress.style.transform = `scaleX(${p})`;
      // Exactly one seek in flight. Never queue old scroll positions or ease
      // through them after a direction change. seeked schedules the latest one.
      if (v.seeking || Math.abs(v.currentTime - this.targetTime) < 1 / 60) return;
      this.seekStarted = performance.now(); v.currentTime = this.targetTime;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.mediaAbort?.abort();
      this.observer?.disconnect(); cancelAnimationFrame(this.raf); this.raf = 0; this.video?.pause();
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
    }
  });
})();
